module.exports = __webpack_public_path__ + "r-v3/img/add_white.cf4f11f0.svg";